import {useTranslation} from "react-i18next";

export function Translation(value) {
    const {t} = useTranslation();
    return t(value);
}
